export default {
  props: {
    from: { type: Date, required: false },
    to: { type: Date, required: false },
    path: { type: String, required: true },
    pathTo: { type: String, required: true },
    pathFrom: { type: String, required: true },
  },
  computed: {
    day() {
      return {
        from: this.from === undefined ? null : this.from.getDate(),
        to: this.to === undefined ? null : this.to.getDate(),
      };
    },
    weekday() {
      return {
        from: this.from === undefined ? null : this.from.getDay(),
        to: this.to === undefined ? null : this.to.getDay(),
      };
    },
    month() {
      return {
        from: this.from === undefined ? null : this.from.getMonth() + 1,
        to: this.to === undefined ? null : this.to.getMonth() + 1,
      };
    },
    year() {
      return {
        from: this.from === undefined ? null : this.from.getFullYear(),
        to: this.to === undefined ? null : this.to.getFullYear(),
      };
    },
    minutes() {
      return {
        from: this.from === undefined ? null : this.from.getMinutes(),
        to: this.to === undefined ? null : this.to.getMinutes(),
      };
    },
    hours() {
      return {
        from: this.from === undefined ? null : this.from.getHours(),
        to: this.to === undefined ? null : this.to.getHours(),
      };
    },
    selectedPath() {
      if (this.from === undefined) {
        return this.pathTo;
      }

      if (this.to === undefined) {
        return this.pathFrom;
      }

      return this.path;
    },
  },
};
